import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { subscriptionApi } from '~/lib/request';

function useTopUp() {
  const result = useMutation({
    mutationFn: (amount: number) =>
      subscriptionApi
        .post('api/balance/topup', {
          json: {
            amount,
            redirectUrl: `${window.location.origin}/subscription`,
          },
        })
        .json<{ url: string }>(),

    onSuccess: (data) => {
      window.location.href = data.url;
    },
    onError: (error) => {
      console.error(error);

      toast.error('Please try again later');
    },
  });

  return result;
}

export default useTopUp;
